import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopSpa = dynamic(() => import('../../components/spa-salon/spa/DesktopSpa'), {
  loading: () => <Loading />,
});
const MobileSpa = dynamic(() => import('../../components/spa-salon/spa/MobileSpa'), {
  loading: () => <Loading />,
});

const spaPOSBillingSoftware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Spa Scheduling, Booking and Appointment Management Software</title>
        <link rel="canonical" href="https://queuebuster.co/spa-and-salon/spa-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/spa-and-salon/spa-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Easily manage spa appointments and bookings with QueueBuster POS. Streamline scheduling and enhance the customer experience with integrated billing. Request a demo today!" />
        <meta property="og:title" content="Spa Scheduling, Booking and Appointment Management Software in India - Get a Free Demo" />
        <meta property="og:description" content="Easily manage spa appointments and bookings with QueueBuster POS. Streamline scheduling and enhance the customer experience with integrated billing. Experience efficiency firsthand with a free demo." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa.jpg" />
        <meta property="og:url" content="https://queuebuster.co/spa-and-salon/spa-pos-billing-software" />
      </Head>
         <SchemaTags page="spa-pos-billing-software" />
      {
        mobileView ? <MobileSpa /> : <DesktopSpa />
      }
    </>
  )
}

export default spaPOSBillingSoftware